const state = () => ({
    account: null,
});

const actions = {
    async setAccount({ commit }, payload) {        
        commit('SET_ACCOUNT', payload);
    },
};

const mutations = {
    SET_ACCOUNT(state, data) {
        state.account = data;
    },
};

const getters = {
    fullName(state) {
        if (!state.account) return '';
        const firstName = state.account.first_name || '';
        const lastName = state.account.last_name || '';

        return `${firstName} ${lastName}`;
    },
    OTPEnable(state) {
        if (!state.account) {
            return false;
        }

        const auths = state.account.two_step_auth || [];
        return auths.length > 0;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};
